import React from "react";
import "./recostMapIdentity.css";

export interface RecostMapIdentityProps {
    candidate: string;
    control?: string;
    vehicleType?: string;
    recostingDataSource?: string;
}

const RecostMapIdentity = ({
    candidate,
    control,
    vehicleType,
    recostingDataSource,
}: RecostMapIdentityProps) => {
    // reformatReleaseMetricsJSON uses MajorTom-region-rsmVersion-build-variant.
    // Shorten only that recognized shape; retain the entire variant and build.
    const parts = candidate.split("-");
    const recognized = parts.length === 5 && parts[0] === "MajorTom" &&
        parts.every(Boolean) && /^\d+$/.test(parts[2]) && /^\d+$/.test(parts[3]);
    const variant = recognized
        ? (parts[4].startsWith(`${parts[1]}_`) ? parts[4] : `${parts[1]} · ${parts[4]}`)
        : undefined;

    return (
        <div className="recost-map-identity">
            <strong>{recognized ? `${parts[2]}-${parts[3]}` : candidate || "n/a"}</strong>
            {variant && <div>{variant}</div>}
            {(vehicleType || recostingDataSource) && (
                <div className="recost-map-identity__metadata">
                    {[vehicleType, recostingDataSource].filter(Boolean).join(" · ")}
                </div>
            )}
            <details className="recost-map-identity__details">
                <summary>Full map IDs</summary>
                <dl>
                    <dt>Candidate</dt>
                    <dd>{candidate || "n/a"}</dd>
                    <dt>Control</dt>
                    <dd>{control || "n/a"}</dd>
                </dl>
            </details>
        </div>
    );
};

export default RecostMapIdentity;
